<template>
  <div>
    <document-element-image-file
      v-if="totalChildren > 0"
      :element="currentImage"
      :parent="element"
      :page="page"
      @on-prev-image="prevImage()"
      @on-next-image="nextImage()"
      @on-open-image="openGallery(element.id, currentImage.file ? currentImage.file : currentImage.file_upload)"
      :is-update-disabled="true"
    />
    <document-element-files
      v-if="edit || totalChildren > 0 || publicUpload"
      :element="element"
      :parent="parent"
      :page="page"
      v-model:modelImagePreview="imagePreview"
      :current-image-index="currentIndex"
      :index="index"
      :is-page-locked="isPageLocked"
    />
  </div>
</template>

<script>
import FilesElement from '../../mixins/FilesElement'

export default {
  disableUpdate: true, // disable default update watch, on heading this has to be done by files element
  mixins: [FilesElement],
  allowedChildElements: ['file'],
  data() {
    return {
      imageListArr: [],
    }
  },
  computed: {
    currentIndex: {
      get() {
        const foundedIndex = this.childrenSorted.findIndex((o) => {
          return o.file?.id === this.imagePreview
        })
        return foundedIndex === -1 ? 0 : foundedIndex
      },
      set(newValue) {
        if (newValue < 0) {
          newValue = this.totalChildren - 1
        }

        if (newValue >= this.totalChildren) {
          newValue = 0
        }

        this.imagePreview = this.childrenSorted[newValue].file ? this.childrenSorted[newValue].file.id : this.childrenSorted[newValue].file_upload.id
      }
    },
    imagePreview: {
      get() {
        return this.element.data.preview__file_id || null
      },
      set(newValue) {
        this.element.data.preview__file_id = newValue
        if (this.bcDocumentStore.edit) {
          this.updated = 'preview__file_id'
        }
      }
    },
    totalChildren() {
      return this.childrenSorted.length
    },
    currentImage() {
      return this.childrenSorted[this.currentIndex]
    }
  },
  methods: {
    prevImage() {
      this.currentIndex--
    },
    nextImage() {
      this.currentIndex++
    },
  },
}
</script>

<style lang="scss" scoped></style>
